import { atom } from 'recoil';

export const currentTeam = atom({
  key: 'currentTeam', // unique ID (with respect to other atoms/selectors)
  default: {
    id: 0,
    name: 'All Teams',
  }, // default value (aka initial value)
});
